import React, { Component } from 'react';

class AccountContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return <h1>Account Page!</h1>;
  }
}

export default AccountContainer;



// WEBPACK FOOTER //
// ./src/container/Account.js